/*
 * Copyright 2025 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.datastore.di

import com.russhwolf.settings.Settings
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module
import studio.oddpods.cauce.core.base.common.di.CommonModule
import studio.oddpods.cauce.core.datastore.NotificationPreferencesRepository
import studio.oddpods.cauce.core.datastore.NotificationPreferencesRepositoryImpl
import studio.oddpods.cauce.core.datastore.UserPreferencesRepository
import studio.oddpods.cauce.core.datastore.UserPreferencesRepositoryImpl

val DatastoreModule = module {
    includes(CommonModule)

    single<Settings> { Settings() }

    singleOf(::UserPreferencesRepositoryImpl) bind UserPreferencesRepository::class
    singleOf(::NotificationPreferencesRepositoryImpl) bind NotificationPreferencesRepository::class
}
